module.exports = __webpack_public_path__ + "static/img/login4.78f4a0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login4.png
// module id = JhYL
// module chunks = 1